import { atom, AtomEffect } from 'recoil'

import User from '../models/User'
import Team from '../models/Team'
import { Referrer } from '../models/Referrer'

export const userState = atom({
    key: 'userState',
    default: {} as User
})

// Sidebar open/collapsed state, shared so the main rail and the admin
// secondary rail collapse in lockstep. Persisted to localStorage (the key the
// rail has always used) so the choice survives reloads.
const persistSidebarOpen: AtomEffect<boolean> = ({ setSelf, onSet }) => {
    const saved = localStorage.getItem('sidebarOpen')
    if (saved !== null) {
        setSelf(saved === 'true')
    }
    onSet((newValue) => {
        localStorage.setItem('sidebarOpen', newValue.toString())
    })
}

export const sidebarOpenState = atom<boolean>({
    key: 'sidebarOpenState',
    default: false,
    effects: [persistSidebarOpen]
})

export const referrerState = atom<Referrer | undefined>({
    key: 'referrerState',
    default: undefined
})

export const guidedOnboardingIncompleteState = atom<boolean | undefined>({
    key: 'guidedOnboardingIncompleteState',
    default: undefined
})

export const userTeamsState = atom({
    key: 'userTeamsState',
    default: {} as Team[]
})

export const isUserAdminState = atom({
    key: 'isUserAdminState',
    default: false
})

export const canUserLikeContentState = atom({
    key: 'canUserLikeContentState',
    default: false
})

export const canUserReplyToContentState = atom({
    key: 'canUserReplyToContentState',
    default: false
})

export const isPlatformAppReviewerState = atom({
    key: 'isPlatformAppReviewerState',
    default: false
})

export const canUseCrossProfileEngageState = atom({
    key: 'canUseCrossProfileEngageState',
    default: false
})
export const canManageShadowBanningState = atom({
    key: 'canManageShadowBanningState',
    default: false
})

export const canChangeCrossProfileEngageDefaultState = atom({
    key: 'canChangeCrossProfileEngageDefaultState',
    default: false
})

export const keywordsEnabledState = atom({
    key: 'keywordsEnabledState',
    default: false
})

export const canViewScreenshotsState = atom({
    key: 'canViewScreenshotsState',
    default: false
})

export const askArwenEnabledState = atom({
    key: 'askArwenEnabledState',
    default: false
})

// Rollout toggle for the conversation drawer. Defaults off so the entry
// points stay hidden until the user's toggles have loaded.
export const conversationViewEnabledState = atom({
    key: 'conversationViewEnabledState',
    default: false
})

export const canLabelSpamState = atom({
    key: 'canLabelSpamState',
    default: false
})

export const canHideContentState = atom({
    key: 'canHideContentState',
    default: false
})

export const canDeleteContentState = atom({
    key: 'canDeleteContentState',
    default: false
})

export const canBlockUserState = atom({
    key: 'canBlockUserState',
    default: false
})

export const canMuteUserState = atom({
    key: 'canMuteUserState',
    default: false
})
